  

    <h2 mat-dialog-title>
      <span  class="groupIcon" ><mat-icon>note_add</mat-icon></span>
     My Forms
      <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </h2>
    <mat-dialog-content>    

      <div class="myforms">      
        <div class="drive mainLink">
          <div class="taskLocation">
            <span (click)="breadCrumbMyFormMainClick()">My Forms</span>
            <span *ngFor="let m of menuHeaderMyForm;let i= index;">
              <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
              <a (click)="breadCrumbMyForm(menuHeaderMyForm, i)">{{ m.label }}</a>
            </span>
          </div>

          
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node"
              matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                  arrow_right
                </mat-icon>
  
                <div class="folderName">
                  <mat-icon class="folder" *ngIf="node.isShared == false"
                    (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                  <mat-icon class="folder" *ngIf="node.isShared == true"
                    (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                  <span class="flname" (click)="getFormFolderWithFormTemplates(node)">{{node.formFolderName}}</span>
                </div>
              </div>
            </mat-tree-node>
  
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"
              *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>
                <div class="folderName">
                  <mat-icon class="folder" *ngIf="node.isShared == false"
                    (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                  <mat-icon class="folder" *ngIf="node.isShared == true"
                    (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                  <span class="flname" (click)="getFormFolderWithFormTemplates(node)">{{node.formFolderName}}</span>
                </div>
              </div>  
            </mat-tree-node>
          </mat-tree>      
        </div>         
      </div>
  
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-flat-button  color="basic" (click)="close()">Cancel</button>
      <button mat-flat-button  color="primary" [disabled]="!selectButtonMyFormShow" (click)="onFolderSelectToMove()">
        Move
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>




